﻿import { Popup as DialogPopup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';

interface Props {
    visible: boolean;
    title: string;
    message: string;
    onHiding: () => void;

    // Primary Action (left side button) (e.g., "Discard" or "Yes")
    primaryActionText: string;
    primaryActionIcon?: string;
    primaryActionType?: 'default' | 'normal' | 'danger' | 'success';
    onPrimaryAction: () => void;

    // Secondary Action (right side button) (e.g., "Keep Editing" or "No")
    secondaryActionText: string;
    secondaryActionIcon?: string;
    onSecondaryAction: () => void;
}

export default function ConfirmationDialog(props: Props) {
    return (
        <DialogPopup
            visible={props.visible}
            onHiding={props.onHiding}
            hideOnOutsideClick={false}
            dragEnabled={false}
            showTitle={true}
            title={props.title}
            width={400}
            height={200}
        >
            <div>
                <p>{props.message}</p>
                <div className="confirmation-dialog-actions">
                    <Button
                        text={props.primaryActionText}
                        icon={props.primaryActionIcon ?? undefined}
                        type={props.primaryActionType ?? "default"}
                        onClick={props.onPrimaryAction}
                    />
                    <Button
                        text={props.secondaryActionText}
                        icon={props.secondaryActionIcon ?? undefined}
                        type="normal"
                        onClick={props.onSecondaryAction}
                    />
                </div>
            </div>
        </DialogPopup>
    );
}